module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "experiment"
  }, [_c('div', {
    ref: "renderer",
    staticClass: "experiment__renderer"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ea5aa48"}!./src/components/experiment/experiment.component.html
// module id = 154
// module chunks = 1